// src/components/modules/wrapper/LoginModalWrapper.js
import React from 'react';
import { LoginUser } from '../../../contexts/LoginUser';
import { useLoginModal } from '../../../contexts/LoginModalContext';

export const LoginModalWrapper = () => {
    const { isOpen, initialView, closeLoginModal, switchToLogin, switchToRegister } = useLoginModal();

    if (!isOpen) return null;

    return (
        <LoginUser
            initialView={initialView}
            onClose={closeLoginModal}
            onSwitchToLogin={switchToLogin}
            onSwitchToRegisterStep1={switchToRegister}
            onSwitchToRegisterStep2={() => {}}
        />
    );
};
